<template>
  <div class="container wei_body">
    <div class="header">新建拉群</div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="10.0rem" class="demo-ruleForm">
        <el-form-item label="群码名称" prop="name">
          <el-input clearable v-model="ruleForm.name" placeholder="请输入群码名称"></el-input>
        </el-form-item>
        <el-form-item label="添加验证" prop="resource">
          <el-radio-group v-model="ruleForm.resource">
            <el-radio label="直接通过"></el-radio>
            <el-radio label="需验证"></el-radio>
          </el-radio-group>
          <p class="tip">（客户添加时无需企业成员确认，自动成为好友）</p>
        </el-form-item>
        <el-form-item label="选择成员：" prop="userid">
          <div class="person">
            <el-tooltip v-for="item of names" :content="item" placement="top" effect="dark" :key="item">
              <el-button>{{ item }}</el-button>
            </el-tooltip>
          </div>
          <el-button class="addBtn" icon="el-icon-plus" @click="addContact">选择成员</el-button>
        </el-form-item>
        <el-form-item label="自动打标签" prop="delivery">
          <el-switch v-model="ruleForm.delivery"></el-switch>
        </el-form-item>
        <el-form-item v-if="ruleForm.delivery" label="选择标签：" prop="userid">
          <div class="person">
            <el-tooltip v-for="item of tagNames" :content="item" placement="top" effect="dark" :key="item">
              <el-button>{{ item }}</el-button>
            </el-tooltip>
          </div>
          <el-button class="addBtn" icon="el-icon-plus" @click="addTag">添加标签</el-button>
        </el-form-item>
        <el-form-item label="入群引导语" prop="desc">
          <el-input clearable type="textarea" autosize="true" v-model="ruleForm.desc" placeholder="请输入入群引导语"></el-input>
        </el-form-item>
        <el-form-item label="添加群聊：" prop="userid">
          <el-button class="addBtn" icon="el-icon-plus" @click="addChat">请选择群聊</el-button>
          <p class="tip2">
            可添加多个群聊，当前面的群人数达到上限后，自动发送后面的群二维码。即当第一个群达到人数上限，客户自动扫码会添加第二个客服，然后进入第二个群聊，依次往后进行。因系统无法判断群二维码是否真实有效，请您准确上传群对应的群二维码，否则会影响拉群效果。
          </p>
          <div class="table">
            <el-table :data="tableData" border style="width: 100%">
              <el-table-column prop="name" label="群名称" width="180"></el-table-column>
              <el-table-column prop="num" label="群人数上限">
                <template slot-scope="{ row }">
                  群人数达到
                  <el-input clearable v-model="row.num" class="edit-input" size="small" />人,换群加入
                </template>
              </el-table-column>
              <el-table-column prop="address" label="二维码" width="180">
                <template slot-scope="{ row }">
                  <div @click="upImg(row)">
                    <el-upload class="avatar-uploader" :action="action" :data="upParams" :show-file-list="false"
                      :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <img v-if="row.imageUrl" :src="row.imageUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" style="color:#F00 !important" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="请选择标签" center :visible.sync="dialogTableVisible">
      <div v-for="item of tags" :key="item.tagId" class="tag-item">
        <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll"
          @change="handleCheckAllChange(item.id)">{{ item.tagName }}</el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="item.checkedCities" @change="handleCheckedCitiesChange(item)">
          <el-checkbox v-for="city in item.cities" :label="city.name" :key="city.id">{{ city.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="offDialog">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
    <right-group ref="drawer" :checkbox="checkbox" @handleSelect="handleSelect"></right-group>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';
import rightGroup from '@/components/drawer/rightGroup';
export default {
  components: {
    rightPeople,
    rightGroup
  },
  data() {
    return {
      checkbox: false,
      dialogTableVisible: false,
      names: "",
      tags: "",
      module: "",
      upParams: {},
      currentId: "",
      action: this.axios.defaults.baseURL + "/api/Alioss/upload_temp_uploadimg",
      imageUrl: "",
      tableData: [],
      ruleForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        userid: "",
        tag_id: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      tags: [
        {
          checkAll: false,
          checkedCities: [],
          cities: [
            {
              id: 1,
              name: "上海",
            },
            {
              id: 2,
              name: "北京",
            },
            {
              id: 3,
              name: "广州",
            },
            {
              id: 4,
              name: "深圳",
            },
          ],
          isIndeterminate: true,
          tagName: "一级城市",
          id: 1,
        },
        {
          checkAll: false,
          checkedCities: [],
          cities: [
            {
              id: 5,
              name: "郑州",
            },
            {
              id: 6,
              name: "武汉",
            },
            {
              id: 7,
              name: "长沙",
            },
            {
              id: 8,
              name: "天津",
            },
          ],
          isIndeterminate: true,
          tagName: "二级城市",
          id: 2,
        },
        {
          checkAll: false,
          checkedCities: ["洛阳", "安阳"],
          cities: [
            {
              id: 9,
              name: "洛阳",
            },
            {
              id: 10,
              name: "南阳",
            },
            {
              id: 11,
              name: "安阳",
            },
            {
              id: 12,
              name: "新郑",
            },
          ],
          isIndeterminate: true,
          tagName: "三级城市",
          id: 3,
        },
      ],
      tagNames: [],
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
    }
  },
  watch: {
    tags: {
      handler(oldVal, newVal) {
        for (const iterator of newVal) {
          for (const i of iterator) {
            this.tagNames.push(i);
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    upImg(row) {
      this.currentId = row.id;
    },
    handleAvatarSuccess(res, file, list) {
      this.imageUrl = URL.createObjectURL(file.raw);
      const index = this.tableData.findIndex((i) => {
        return i.id === this.currentId;
      });
      this.tableData[index].imageUrl = this.imageUrl;
    },
    beforeAvatarUpload(file) { },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.names = "";
      this.tableData = [];
    },
    addContact() {
      this.module = "getUserList";
      this.checkbox = false;
      this.$refs.dialog.open();
    },
    addTag() {
      this.dialogTableVisible = true;
    },
    addChat() {
      this.module = "getGroupChat";
      this.checkbox = true;
      this.$refs.drawer.open();
    },
    handleSelect(person) {
      if (this.module === "getUserList") {
        const userid = [];
        const user = [];
        person.map((item) => {
          userid.push(item.userid);
          user.push(item.name);
        });
        this.ruleForm.userid = userid.join();
        this.names = user;
      }
      if (this.module === "getGroupChat") {
        const chatid = [];
        const chat = [];
        for (const item of person) {
          const findItem = this.tableData.find((i) => {
            return item.chat_id === i.chat_id;
          });
          if (!findItem) {
            this.tableData.push({
              chat_id: item.chat_id,
              name: item.name,
              owner_name: item.owner_name,
              imageUrl: "",
              num: 200,
            });
          }
        }
      }
    },
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    offDialog() {
      this.dialogTableVisible = false;
    },
    handleCheckAllChange(val) { },
    handleCheckedCitiesChange(value) { },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
}

.tip {
  color: #999;
  line-height: 1.4;
}

.tip2 {
  @extend .tip;
  margin-top: 1.0rem;
}

.addBtn {
  margin-top: 1.0rem;
}

.header {
  text-indent: 1em;
  line-height: 4.0rem;
  background: rgb(230, 227, 227);
  margin-bottom: 1.0rem;
}

.content {
  padding: 1.0rem;
}

.table {
  margin-top: 2.0rem;
}

.edit-input {
  max-width: 10.0rem;
}

.qrCode {
  width: 10.0rem;
  height: 10.0rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

.tag-item {
  margin: 2.0rem 0;
}

::v-deep .el-table th,
.el-table tr {
  background-color: #f2f2f2 !important;
  color: #333;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader .avatar-uploader-icon {
  font-size: 2.8rem;
  color: #8c939d;
  width: 10.0rem;
  height: 10.0rem;
  line-height: 10.0rem !important;
  text-align: center;
}

.avatar {
  width: 10.0rem;
  height: 10.0rem;
  display: block;
}
</style>
